export default "__VITE_ASSET__538f79d1__"